/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Cancel_Note_PlaceholderInputs */

const vi_carrier_cancel_note_placeholder = /** @type {(inputs: Carrier_Cancel_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do huỷ (gửi cho hãng vận chuyển)`)
};

/**

* @param {Carrier_Cancel_Note_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_cancel_note_placeholder = /** @type {((inputs?: Carrier_Cancel_Note_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Cancel_Note_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_cancel_note_placeholder(inputs)
});